import script from "./Popup5.vue?vue&type=script&setup=true&lang=js"
export * from "./Popup5.vue?vue&type=script&setup=true&lang=js"

import "./Popup5.vue?vue&type=style&index=0&id=2485561e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2485561e"]])

export default __exports__